import React from "react";
import Skeleton from "react-loading-skeleton";
import Container from "./styles";

const AdminListItem = ({
  firstName,
  lastName,
  phone,
  email,
  role,
  status,
  loading,
  onClick
}) => {
  if (loading) {
    return (
      <Container>
        <div className="img--container">
          <Skeleton circle width={100} height={100} />
        </div>
        <h3><Skeleton width={120} /></h3>
        <p><Skeleton width={100} /></p>
        <Skeleton width={80} height={25} />
      </Container>
    )
  }

  return (
    <Container
      role="button"
      onClick={() => {
        if (onClick && typeof onClick === "function") {
          onClick();
        }
      }}
    >
      <div className="img--container">
        {firstName && lastName ? `${firstName[0]}${lastName[0]}` : "PO"}
      </div>
      <h3>{firstName && lastName ? `${firstName} ${lastName}` : <Skeleton width={"7rem"} />}</h3>
      <p>{phone || <Skeleton width={"7rem"} />}</p>
      {role && <span className={`role-badge ${role.toLowerCase()}`}>{role.replace('_', ' ')}</span>}
    </Container>
  );
};

export default AdminListItem;
